import 'css-chunk:src/app/containers/MemberDetail/components/MemberDetails/components/SalesTracking/SalesTracking.scss';export default {
  "copyBtn": "_copyBtn_3u7ry_1",
  "offer": "_offer_3u7ry_6",
  "noOffers": "_noOffers_3u7ry_10"
};